import React, { useMemo, useState } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import pointsIcon from '../../../theme/assets/svg/b_cabinet_partners_points_icon.svg';
import usdtIcon from '../../../theme/assets/svg/b_cabinet_partners_usdt_icon.svg';
import warningIcon from '../../../theme/assets/svg/b_cabinet_partners_warning_icon.svg';
import {exchangePoints, setCabinetPartnersConvertPointsHistoryModalStatus} from "../../../store/cabinet/action";
import {toast} from "react-toastify";

const PERCENT_OPTIONS = [25, 50, 75, 100];

const formatAmount = (value, precision = 8) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "0";

    return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: precision,
    }).format(numberValue);
};

const formatUsdt = (value) => {
    const numberValue = Number(value);

    if (!Number.isFinite(numberValue)) return "0";

    return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 8,
    }).format(numberValue);
};

const parseAmount = (value) => {
    if (!value) return 0;

    const normalizedValue = String(value)
        .replace(/\s/g, "")
        .replace(",", ".");

    const numberValue = Number(normalizedValue);

    return Number.isFinite(numberValue) ? numberValue : 0;
};

const getPointsBalance = (data) => {
    return Number(data?.points || 0);
};

const getCurrentRate = (data) => {
    return Number(data?.current_rank?.points_to_usd || 0);
};

const CabinetPartnersConvertPoints = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const partnersMainData = useSelector(store => store.cabinet.partnersMainData);
    const exchangePointsStatusStarted = useSelector(store => store.cabinet.exchangePointsStatusStarted);



    const pointsBalance = getPointsBalance(partnersMainData);
    const pointsToUsdRate = getCurrentRate(partnersMainData);

    const [pointsAmount, setPointsAmount] = useState("");

    const pointsAmountNumber = useMemo(() => {
        return parseAmount(pointsAmount);
    }, [pointsAmount]);

    const usdtAmount = useMemo(() => {
        return pointsAmountNumber * pointsToUsdRate;
    }, [pointsAmountNumber, pointsToUsdRate]);

    const isAmountValid = pointsAmountNumber > 0 && pointsAmountNumber <= pointsBalance && !exchangePointsStatusStarted;

    const amountChangeHandler = (event) => {
        const value = event.target.value;

        if (!/^[0-9.,]*$/.test(value)) return;

        setPointsAmount(value);
    };

    const percentClickHandler = (percent) => {
        const calculatedAmount = pointsBalance * percent / 100;

        setPointsAmount(String(calculatedAmount));
    };

    const successHandler = () => {
        setPointsAmount("");

        toast('Вы успешно отправили заявку на обмен, ожидайте завершения транзакции!');
    }

    const convertHandler = () => {
        if (!isAmountValid) return;

        dispatch(exchangePoints({points: pointsAmountNumber}, successHandler))

    };

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.title}>
                        {t("Конвертировать баллы")}
                    </div>
                    <div className={Styles.historyBtn} onClick={()=>{dispatch(setCabinetPartnersConvertPointsHistoryModalStatus(true))}}>
                        {t('История конвертации баллов')}
                    </div>
                </div>


                <div className={Styles.formWrap}>
                    <div className={Styles.inputWrap}>
                        <input
                            type="text"
                            value={pointsAmount}
                            onChange={amountChangeHandler}
                            placeholder={`${t("Вы отдаёте")}: 1.000`}
                        />

                        <div className={Styles.currencyBadge}>
                            <div className={Styles.badgeIcon}>
                                <img src={pointsIcon} alt="kairo points"/>
                            </div>

                            <span>Points</span>
                        </div>
                    </div>

                    <div className={Styles.balanceRow}>
                        <div className={Styles.balanceIcon}>
                            <img src={pointsIcon} alt="kairo points"/>
                        </div>

                        <div className={Styles.balanceText}>
                            {t("Ваш баланс")}: <span>{formatAmount(pointsBalance)} Points</span>
                        </div>
                    </div>

                    <div className={Styles.percentWrap}>
                        {PERCENT_OPTIONS.map((percent) => (
                            <button
                                type="button"
                                className={Styles.percentBtn}
                                key={percent}
                                onClick={() => percentClickHandler(percent)}
                                disabled={!pointsBalance}
                            >
                                {percent}%
                            </button>
                        ))}
                    </div>

                    <div className={Styles.separator} />

                    <div className={Styles.inputWrap}>
                        <input
                            type="text"
                            value={formatUsdt(usdtAmount)}
                            placeholder={`${t("Вы получаете")}: 1.000`}
                            readOnly
                        />

                        <div className={Styles.currencyBadge}>
                            <div className={Styles.badgeIcon}>
                                <img src={usdtIcon} alt="usdt"/>
                            </div>

                            <span>USDT</span>
                        </div>
                    </div>

                    <div className={Styles.rateRow}>
                        <div className={Styles.rateIcon}>
                            <img src={warningIcon} alt="rate warning"/>
                        </div>

                        <div className={Styles.rateText}>
                            {t("Курс")}: 1 Point = {formatUsdt(pointsToUsdRate)} USDT
                        </div>
                    </div>
                </div>

                <button
                    type="button"
                    className={Styles.convertBtn}
                    onClick={convertHandler}
                    disabled={!isAmountValid}
                >
                    {t("Конвертировать в USDT")}
                </button>
            </div>
        </div>
    );
};

export default CabinetPartnersConvertPoints;